package co.maytes.standupbot.dashboard.features.setup

import co.maytes.standupbot.dashboard.stores.ToastKind
import co.maytes.standupbot.shared.oauth.OAuthOutcome
import co.maytes.standupbot.shared.oauth.OAuthReasonCopy
import co.maytes.standupbot.shared.oauth.OAuthResult

data class OAuthOutcomeNotice(
    val message: String,
    val kind: ToastKind,
    val cleanedSearch: String,
    val verifiesConnection: Boolean = false,
)

object OAuthOutcomeNotices {
    fun fromSearch(search: String): OAuthOutcomeNotice? {
        val outcome = OAuthOutcome.fromQuery(search) ?: return null
        return OAuthOutcomeNotice(
            message = OAuthReasonCopy.message(outcome),
            kind = if (outcome.result == OAuthResult.OK) ToastKind.Success else ToastKind.Error,
            cleanedSearch = OAuthOutcome.withoutOutcomeParams(search),
            verifiesConnection = outcome.result == OAuthResult.OK,
        )
    }
}
